/**
 * Font Scaling Utilities for Browser Zoom Support
 *
 * Purpose: Enable text to scale with browser zoom (up to 200%) while
 * keeping layout dimensions stable in pixels.
 *
 * Usage: Only convert fontSize properties, not layout dimensions.
 *
 * Example:
 *   fontSize: rem(14) + 'rem'  // ✅ Scales with zoom
 *   height: 56                 // ✅ Stays fixed
 *   fontSize: rem(14) + 'rem',
 *   padding: rem(10) + 'rem'   // ❌ Don't convert padding
 *
 * Accessibility: Meets WCAG 2.1 AA/AAA (SC 1.4.4 - Resize text up to 200%)
 */

/**
 * Convert pixel font sizes to rem for browser zoom support
 * Layout stays in px, only text scales
 *
 * @param {number} pixels - Font size in pixels
 * @returns {number} Font size in rem units
 *
 * @example
 * // At 100% zoom: 1rem = 16px → 0.875rem = 14px
 * // At 150% zoom: 1rem = 24px → 0.875rem = 21px
 * // At 200% zoom: 1rem = 32px → 0.875rem = 28px
 * rem(14) // Returns 0.875
 */
export function rem(pixels) {
  return pixels / 16; // 16px = 1rem base
}

/**
 * For React Native Web StyleSheet - returns fontSize object
 *
 * @param {number} pixels - Font size in pixels
 * @returns {object} Style object with fontSize in rem
 *
 * @example
 * const styles = StyleSheet.create({
 *   text: {
 *     ...fontSize(14), // Returns { fontSize: '0.875rem' }
 *   }
 * });
 */
export function fontSize(pixels) {
  return { fontSize: rem(pixels) + 'rem' };
}
